import InputField from '@components/InputField';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import IconButton from '@mui/material/IconButton';
import React, { forwardRef, useState } from 'react';

interface PasswordInputProps {
    label: React.ReactNode;
    value: string;
    onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
    onBlur?: (e: React.FocusEvent<HTMLInputElement>) => void;
    name?: string;
    className?: string;
    disabled?: boolean;
    error?: boolean;
    helperText?: React.ReactNode;
    placeholder?: string;
    fullWidth?: boolean;
    autoComplete?: string;
}

const PasswordInput = forwardRef<HTMLInputElement, PasswordInputProps>(({
    label,
    value,
    onChange,
    onBlur,
    name,
    className,
    disabled,
    error,
    helperText,
    placeholder,
    fullWidth,
    autoComplete,
}, ref) => {
    const [showPassword, setShowPassword] = useState(false);

    return (
        <InputField
            inputRef={ref}
            label={label}
            type={showPassword ? 'text' : 'password'}
            value={value}
            onChange={onChange}
            onBlur={onBlur}
            name={name}
            className={className}
            disabled={disabled}
            error={error}
            helperText={helperText}
            placeholder={placeholder}
            fullWidth={fullWidth}
            autoComplete={autoComplete}
            InputProps={{
                endAdornment: (
                    <IconButton
                        aria-label="toggle password visibility"
                        onClick={() => setShowPassword((prev) => !prev)}
                        onMouseDown={(e) => e.preventDefault()}
                        edge="end"
                        sx={{ color: '#939393' }}
                    >
                        {showPassword ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                ),
            }}
        />
    );
});

PasswordInput.displayName = 'PasswordInput';

export default PasswordInput;
